import React from 'react';
import './MusicMarketingThirdSection.scss';
import PlayArrowIcon from '../../../assets/Images/Marketing/tik tak icon element.svg';
import MusicNoteIcon from '../../../assets/Images/Marketing/spotify icon element (1).svg';
import CameraAltIcon from '../../../assets/Images/Marketing/Instagram icon element.svg';
import WifiIcon from "../../../assets/Images/Marketing/meta icon element.svg";
import InfinteIcon from "../../../assets/Images/Marketing/yt icon element.svg";
import VideoGif from "../../../assets/Images/Marketing/muisc Marketing video.gif";
import { useNavigate } from 'react-router-dom';

const MusicMarketingThirdSection = () => {





    return (
        <div className="music-marketing-third-section">
            <div className="content">
                <h2>Digital Advertising</h2>
                <p>
                    Expand your fanbase on Meta, TikTok, Spotify, and YouTube with precision-targeted ads.
                </p>
                <p>
                    Ready to take your growth to the next level? Leverage our label services to run dedicated ad campaigns that maximize the impact of your music release.
                </p>
                <p>
                    Our team will work closely with you to identify your audience and ensure your music reaches future fans.
                </p>
            </div>
            <div className="image-container">
                <img src={VideoGif} alt="Digital Advertising" />
                <div className="icons">
                    <img src={PlayArrowIcon} alt="TikTok" className="icon-play" />
                    <img src={MusicNoteIcon} alt="Spotify" className="icon-music" />
                    <img src={CameraAltIcon} alt="Instagram" className="icon-camera" />
                    <img src={WifiIcon} alt="Meta" className="icon-wifi" />
                    <img src={InfinteIcon} alt="YouTube" className="icon-infinite" />
                </div>
            </div>
        </div>
    );
};

export default MusicMarketingThirdSection;
